export default "__VITE_ASSET__DwCyRX25__"